import { motion } from "motion/react";
import { Phone, MapPin, ArrowUp, Mail } from "lucide-react";
import { siteData } from "../data/mock";

export const Footer = () => {
  const { clinic } = siteData;
  const address = clinic.address;
  const year = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer role="contentinfo" style={{ background: "#232323" }}>
      {/* Main footer */}
      <div className="max-w-[1280px] mx-auto px-5 md:px-9 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <p
              className="mb-3"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: "1.35rem",
                fontWeight: 600,
                color: "#FFFFFF",
              }}
            >
              Young Vitality Acupuncture
            </p>
            <p
              className="mb-5"
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "0.85rem",
                lineHeight: 1.6,
                color: "rgba(255,255,255,0.5)",
              }}
            >
              Expert acupuncture, cupping therapy, and personalized
              healing in Woodland Hills.
            </p>
            <a
              href={clinic.phoneLink}
              className="inline-flex items-center gap-2 no-underline text-white/70 hover:text-white transition-colors duration-200"
            >
              <Phone size={14} strokeWidth={1.5} />
              <span className="font-mono text-xs">{clinic.phone}</span>
            </a>
            <br />
            <a
              href={`mailto:${clinic.email}`}
              className="inline-flex items-center gap-2 no-underline text-white/70 hover:text-white transition-colors duration-200 mt-2"
            >
              <Mail size={14} strokeWidth={1.5} />
              <span className="font-mono text-xs">{clinic.email}</span>
            </a>
          </div>

          {/* Quick links */}
          <div>
            <p
              className="mb-4"
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "0.75rem",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                color: "rgba(255,255,255,0.4)",
              }}
            >
              Quick Links
            </p>
            <nav aria-label="Footer navigation">
            <div className="flex flex-col gap-2.5">
              {[
                { label: "About", href: "#about" },
                { label: "Services", href: "#services" },
                { label: "Testimonials", href: "#testimonials" },
                { label: "Contact", href: "#contact" },
              ].map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollTo(link.href)}
                  className="bg-transparent border-none text-left cursor-pointer p-0 hover:text-white transition-colors duration-200"
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "0.85rem",
                    color: "rgba(255,255,255,0.55)",
                  }}
                >
                  {link.label}
                </button>
              ))}
            </div>
            </nav>
          </div>

          {/* Address */}
          <div>
            <p
              className="mb-4"
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "0.75rem",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                color: "rgba(255,255,255,0.4)",
              }}
            >
              Location
            </p>
            <div className="flex items-start gap-2.5">
              <MapPin size={15} strokeWidth={1.5} color="rgba(255,255,255,0.4)" className="mt-0.5 flex-shrink-0" />
              <div>
                <p
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "0.85rem",
                    color: "rgba(255,255,255,0.55)",
                    margin: "0 0 2px 0",
                    lineHeight: 1.5,
                  }}
                >
                  {address.street}
                </p>
                <p
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "0.85rem",
                    color: "rgba(255,255,255,0.55)",
                    margin: "0 0 4px 0",
                  }}
                >
                  {address.city}, {address.state} {address.zip}
                </p>
                <p
                  className="font-mono text-[10px] uppercase tracking-widest"
                  style={{ color: "rgba(255,255,255,0.3)", margin: 0 }}
                >
                  {address.area}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        className="border-t"
        style={{ borderColor: "rgba(255,255,255,0.08)" }}
      >
        <div className="max-w-[1280px] mx-auto px-5 md:px-9 py-5 flex items-center justify-between">
          <p
            className="font-mono text-[10px] uppercase tracking-wider"
            style={{ color: "rgba(255,255,255,0.3)", margin: 0 }}
          >
            &copy; {year} {clinic.name}
          </p>
          <button
            onClick={scrollToTop}
            className="w-8 h-8 rounded-full flex items-center justify-center bg-transparent cursor-pointer hover:bg-white/10 transition-colors duration-200"
            style={{ border: "1px solid rgba(255,255,255,0.15)" }}
            aria-label="Back to top"
          >
            <ArrowUp size={14} color="rgba(255,255,255,0.5)" />
          </button>
        </div>
      </div>
    </footer>
  );
};
